import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

// Redux
import { connect } from 'react-redux';
import { clearErrors } from '../../../../redux/actions/alertActions';

// Components
import FloorForm from '../../../../components/FloorForm';

// Constants
import { DEFAULT } from '../../../../constants';
import PageHeader from '../../../../components/PageHeader';

class CreateFloor extends Component {

  constructor(props) {
    super(props);

    this.state = {
      redirectToFloor: false
    };
  }

  componentWillUnmount() {
    this.props.clearErrors();
  }

  render() {
    return this.state.redirectToFloors || !this.props.setupMode ? <Redirect to='/admin/floors' /> : (
      <>
        <PageHeader title='Add a Floor' />
        <FloorForm onSuccess={() => this.setState({ redirectToFloors: true })} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  statusColor: state.status.schoolStatus ? state.status.schoolStatus.getColor() : DEFAULT,
  isMobile: state.ui.isMobile,
  isFullWidth: state.ui.isFullWidth,
  setupMode: state.setupMode.mode || state.setupMode.isLoading
});

const mapDispatchToProps = dispatch => ({
  clearErrors: () => dispatch(clearErrors())
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateFloor);

CreateFloor.propTypes = {
  clearErrors: PropTypes.func,
  statusColor: PropTypes.object,
  isMobile: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  setupMode: PropTypes.setupMode
};
